import { apiPost } from '../../utils/api';

export const removeOrgUser = (org_id, user_id, adm_action_annotation) => {
  return apiPost(`/organization/${org_id}`, 'remove_access', {
    user_id,
    adm_action_annotation,
  });
};
